import SelectLeads from './SelectLeads.component';

export default SelectLeads;